import {pickBy, has, moment, pluralize, find, ordinalize, size, split, last, ordinalizeOrLast, createSelector} from 'helpers';
import {today} from 'store/common';
import {perDay} from 'store/activities/selectors';

const week = ' Mon Tue Wed Thu Fri Sat Sun'.split(' ');

export const repetition = createSelector(
  [ today ],
  ( today ) => ({ endDate, ...activity } = {}) => {
    const parts = split(stringify(activity, today), ' | ');

    if (perDay(activity) > 1) {
      return parts.join(' ') + ' | ' + `${perDay(activity)} times / day`;
    }

    if (endDate) {
      return parts.join(' ') + ' | until '.concat(moment.unix(endDate).format())
    }

    return parts.join(' | ');
    // perDay(activity) > 1 && `${perDay(activity)} times / day`,
    // perDay(activity) < 2 && endDate && ,

  }
);

export const briefRepetition = createSelector(
  [ today ],
  ( today ) => (activity = {}) => (stringify(activity, today) || '').replace(/ \| /g, ' '),
);

function stringify({ repeatCount, repeatDays, repeatType, repetitionInterval, months, ts, scheduleDate }, today) {
  const dayRepeatType = find(['day', 'weekday', 'weekend_day'], val => val == repeatDays);

  switch (repeatType || 'OneTime') {
    case 'PerDay':
      return humanizeWeekDays(repeatDays);

    case 'PerWeek':
      return repeatCount && `${repeatCount} ${pluralize('day', repeatCount)} per week`;

    case 'Monthly':
      if (repeatCount == 1) {
        return repeatDays && `${split(repeatDays, ',').map(ordinalize).join(', ')} of the month`;
      }
      return repeatDays && `${split(repeatDays, ',').map(ordinalize).join(', ')} every ${repeatCount} ${pluralize('month', repeatCount)}`;

    case 'PeriodDays':
      return repeatCount && `every ${repeatCount} ${pluralize('day', repeatCount)}`;

    case 'Weekly':
      if (repeatCount == 1) {
        return humanizeWeekDays(repeatDays);
      }
      return repeatDays && `${stringifyWeekDays(repeatDays)} | every ${repeatCount} ${pluralize('week', repeatCount)}`;

    case 'Weekly_Specific':
      return repeatDays && `${ordinalizeOrLast(repeatCount)} ${dayRepeatType ? dayRepeatType.replace('_', ' ') : stringifyWeekDays(repeatDays)} of the month`;

    case 'Yearly':
      if (!repeatDays) {
        return ordinalize(moment.unix(scheduleDate).date()) + ' of ' + stringifyMonths(months, 'the month') +
               humanizeYears(repetitionInterval);
      }
      return ordinalizeOrLast(repeatCount) + ` ${dayRepeatType ? dayRepeatType.replace('_', ' ') : stringifyWeekDays(repeatDays)} of ` + stringifyMonths(months, 'the month') +
             humanizeYears(repetitionInterval);


    case 'OneTime':
      if (!ts) {
        return 'Someday';
      } else if (ts == today.unix()) {
        return 'Today';
      } else if (ts == today.unix() + 24*60*60) {
        return 'Tomorrow';
      }
      return moment.unix(ts).format();

    default:
      return '';
  }
}

function humanizeWeekDays(days) {
  if (days == '6,7') {
    return 'Every weekend';
  } else if (days == '1,2,3,4,5') {
    return 'Every weekday';
  } else if (days == '1,2,3,4,5,6,7') {
    return 'Every day';
  } else if (size(days)) {
    return 'Every ' + split(days, ',').map(index => week[index]).join(', ');
  }
}

function humanizeYears(value) {
  if (value > 1) {
    return ' | every '.concat(value + pluralize(' year', value));
  }
  return '';
}

function stringifyWeekDays(value) {
  let days = split(value, ',').map(index => week[index]);
  if (days.length > 4) {
    days = days.map(day => day.substr(0, 2));
  }
  return days.join(', ');
}

export function stringifyMonths(value, allLabel) {
  const months = split(value, ',').filter(Boolean);
  if (months.length == 12 && allLabel) {
    return allLabel;
  }
  return months.map(index => moment.monthsShort('MM')[index - 1]).join(', ');
}

export function repetitionValues(activity) {
  const values = {
    endDate: null,
    months: null,
    repeatCount: null,
    repeatCountPerDay: null,
    repeatDays: null,
    repeatType: null,
    repetitionInterval: null,
    scheduleDate: null,
    ts: null,
  }
  return {
    ...values,
    ...pickBy(activity, (value, key) => has(values, key))
  }
}
